<template>
     <div class="js-feed-container js-no-results">
            <h3>{{error.status}}. That's an error.</h3>
            <p>There was an error in your feed <em>{{error.request.responseURL}}</em>:<br />"{{error.data.message}}".</p>
    </div>
</template>

<script>
export default {
  props: {
    error: {
      type: Object
    }
  }
}
</script>
